/**Default board configuration values*/
export const RcsbFvDefaultConfigValues = {
    increasedView: 1.5,
    trackColor: "#FFFFFF",
    displayColor: "#000000",
    trackHeight: 20,
    trackAxisHeight: 30,
    trackWidth: 920,
    rowTitleWidth: 160,
    displayDomain: [0, 1],
    interpolationType: "step" /* InterpolationTypes.STEP */,
    rowHideTransitionTimeout: 500,
    titleAndTrackSpace: 2,
    borderWidth: 1,
    borderColor: "#CCC",
    rowGlowWidth: 1,
    hideInnerBorder: true,
    hideRowGlow: false,
    rowGlowColor: "rgba(255,204,204,0.75)"
};
